export const color = {
	primary: '#BC948F',
	secondary: '#ffffff',
	tertiary: '#ffffff',
	headerLogo: '#43484D',

	blackOne: '#000',
	blackTwo: '#43484D',

	buttonNextBgColor: '#BC948F',
	buttonNextTextColor: '#ffffff',
	buttonNextMobileColor: '#BC948F',
	buttonNextMobileTextColor: '#000',
	buttonNextBorderColor: '#BC948F',
	buttonNextMobileBorderColor: '#BC948F',
	buttonNextHoverBgColor: '#ffffff',
	buttonNextHoverTextColor: '#BC948F',
	buttonNextHoverBorderColor: '#BC948F',

	buttonBackBgColor: '#ffffff',
	buttonBackTextColor: '#BC948F',
	buttonBackMobileBgColor: '#BC948F',
	buttonBackMobileTextColor: '#000',
	buttonBackBorderColor: '#BC948F',
	buttonBackMobileBorderColor: '#BC948F',
	buttonBackHoverBgColor: '#BC948F',
	buttonBackHoverTextColor: '#fff',
	buttonBackHoverBorderColor: '#BC948F',

	exchangeSelectBtnTextColor: '#ffffff',
	exchangeSelectBtnBgColor: '#BC948F',
	exchangeSelectBtnBorderColor: '#BC948F',
	exchangeSelectBtnBorderSize: '2px',
	exchangeSelectBtnSVGColor: '#ffffff',

	exchangeDontSelectBtnTextColor: '#ffffff',
	exchangeDontSelectBtnBgColor: '#000000',
	exchangeDontSelectBtnBorderColor: '#000000',
	exchangeDontSelectBtnBorderSize: '2px',
	exchangeDontSelectBtnSVGColor: '#ffffff',

	exchangeRemoveSelectBtnTextColor: '#ffffff',
	exchangeRemoveSelectBtnBgColor: '#000000',
	exchangeRemoveSelectBtnBorderColor: '#000000',
	exchangeRemoveSelectBtnBorderSize: '2px',
	exchangeRemoveSelectBtnSVGColor: '#ffffff',

	flowButtonSelectedTextColor: '#000000',
	flowButtonSelectedBgColor: '#BC948F',
	flowButtonSelectedBorderColor: '#BC948F',

	flowButtonOriginalTextColor: '#000000',
	flowButtonOriginalBgColor: '#ffffff',
	flowButtonOriginalBorderColor: '#000000',

	grayOne: '#E6E6E6',
	grayTwo: '#f7f7f7',
	grayThree: '#666',
	grayFour: '#C4C4C4',
	grayFive: '#DCDCDC',
	graySix: '#A6A6A6',
	graySeven: '#F1F1F1',
	grayEight: '#F5F5F5',
	grayTen: '#666666',
	grayEleven: '#EDEDED',
	grayTwelve: '#E6E6E6',
	grayThirteen: '#DADADA',
	grayFourteen: '#696969',
	grayFifteen: '#E5E5E5',
	graySixteen: '#E2E2E2',
	graySeventeen: '#D3D3D3',
	grayEighteen: '#5E5E5E',
	grayNineteen: '#A1A1A1',

	greenTwo: '#D7F2EA',
	greenThree: '#D7F2EA',
	greenFour: 'rgba(45,205,178,0.2)',

	redOne: '#EA0000',
	redTwo: '#F32727',
}
